<script>
  // Usage: Render and control visibility with the isOpenStore:writable(val:boolean) prop
  import { onDestroy, onMount } from "svelte"
  import { writable } from "svelte/store"

  export let closeButtonClasses
  export let dialogElement = null
  export let headerClasses
  export let isOpenStore = null

  let currentIsOpen = false
  let previousIsOpen = false
  let unsubscribeIsOpen = () => {}

  function close() {
    dialogElement.addEventListener(
      "transitionend",
      function onTransitionEnd() {
        dialogElement.close()
        dialogElement.removeEventListener("transitionend", onTransitionEnd)
      },
      { once: true }
    )

    dialogElement.classList.remove("backdrop:opacity-100", "opacity-100", "scale-100")
    dialogElement.classList.add("backdrop:opacity-0", "opacity-0", "scale-95")
  }

  function handleClose() {
    isOpenStore.set(false)
  }

  function handleKeyDown(e) {
    if (e.key === "Escape" && dialogElement.open) {
      e.preventDefault()
      handleClose()
    }
  }

  function open() {
    dialogElement.showModal()

    requestAnimationFrame(() => {
      dialogElement.classList.remove("backdrop:opacity-0", "opacity-0", "scale-95")
      dialogElement.classList.add("backdrop:opacity-100", "opacity-100", "scale-100")
    })
  }

  onDestroy(() => {
    unsubscribeIsOpen()
  })

  onMount(() => {
    isOpenStore = writable(false)

    unsubscribeIsOpen = isOpenStore.subscribe((nextIsOpen) => {
      previousIsOpen = currentIsOpen
      currentIsOpen = nextIsOpen

      if (!previousIsOpen && nextIsOpen) {
        open()
      }

      if (previousIsOpen && !nextIsOpen) {
        close()
      }
    })
  })

  $: resolvedCloseButtonClasses = closeButtonClasses ? closeButtonClasses : "hover:bg-slate-100"
  $: resolvedHeaderClasses = headerClasses ? headerClasses : "border-gray-200"
</script>

<svelte:window on:keydown={handleKeyDown} />

<dialog
  bind:this={dialogElement}
  class="backdrop:opacity-0 duration-300 focus:outline-none max-w-[24rem] opacity-0 rounded-lg scale-95 shadow-lg transition-[height,opacity,width] transition-transform w-[90vw]"
>
  <header class="border-b flex gap-2 justify-between p-4 {resolvedHeaderClasses}">
    <slot name="header" />

    <button
      class="border focus:outline-none rounded-md p-2 self-start transition-colors {resolvedCloseButtonClasses}"
      on:click={handleClose}
      type="button"
    >
      <svg
        aria-hidden="true"
        class="h-5 w-5"
        fill="currentColor"
        id="x-mark"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clip-rule="evenodd"
          d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
          fill-rule="evenodd"
        />
      </svg>
    </button>
  </header>

  <section>
    <slot name="body" />
  </section>
</dialog>
